module.exports = __webpack_public_path__ + "img/logo1.6d90865e.png";